import { BoxStyleProps } from "@twilio-paste/core/box";
import { CSSProperties } from "react";
import { keyframes } from "@emotion/core";

export const popIn = keyframes`
    0% {
        transform: scale(0);
    }
    100% {
        transform: scale(1);
    }
`;

export const popOut = keyframes`
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(0);
    }
`;



export const outerContainerStyles: BoxStyleProps = {
    position: "fixed",
    bottom: "space50",
    right: "space60",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
};

export const innerContainerStyles: BoxStyleProps = {
    boxShadow: "shadow",
    display: "flex",
    flexDirection: "column",
    width: "350px",
    height: "540px",
    marginBottom: "space50",
    borderRadius: "borderRadius30",
    backgroundColor: "colorBackgroundBody",
};

export const myInnerContainerStyles:CSSProperties = {
    boxShadow: "shadow",
    display: "flex",
    flexDirection: "column",
    width: "350px",
    height: "540px",
    marginBottom: "space50",
    borderRadius: "borderRadius30",
    backgroundColor: "colorBackgroundBody"
}
